import { PageAppletCapability } from '@doxyme/extensions-bridge';
import {
  type Specs,
  useBasicObservableOptional,
  useCapability,
} from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

type Applet = Specs.PageApplet.Applet;

export type UseExtensionsPageAppletReturnValue = {
  applet: Applet | undefined;
  attach?: InstanceType<typeof PageAppletCapability>['attachApplet'];
  detach?: InstanceType<typeof PageAppletCapability>['detachApplet'];
  close?: InstanceType<typeof PageAppletCapability>['close'];
};

export function useExtensionsPageApplet(): UseExtensionsPageAppletReturnValue {
  const pageApplet = useCapability<PageAppletCapability>(
    bridge,
    PageAppletCapability.id,
  );

  const [applet] = useBasicObservableOptional<Applet | undefined>(
    undefined,
    pageApplet?.getActiveFrame(),
  );

  return {
    applet,
    attach: pageApplet?.attachApplet.bind(pageApplet),
    detach: pageApplet?.detachApplet.bind(pageApplet),
    close: pageApplet?.close.bind(pageApplet),
  };
}
